/* eslint-disable react/no-unknown-property */
import React from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosMaisBuscados.css';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';

function CarrosEletricosMaisBuscados() {
  return (
    <>
      <section id="carros-eletricos-mais-buscados">
        <Container>
          <div className="carros-eletricos-mais-buscados-circles-1" />
          <h3 className="carros-eletricos-mais-title">
            Veículos <b>elétricos</b> e <b>híbridos</b> mais buscados:
          </h3>

          <div className="carros-eletricos-mais-cars">
            <div className="carros-eletricos-mais-cars-card">
              <h4 className="carros-eletricos-mais-cars-title">
                <b>1°</b> BYD Song Plus
              </h4>
              <p className="carros-eletricos-mais-subtitle"> Veículo Recarregável Plug-in (PHEV)</p>
              <div className="carros-eletricos-mais-cars-img">
                <picture>
                  <source type="image/webp" srcSet="assets/carros-eletricos/byd.webp" />
                  <source type="image/png" srcSet="assets/carros-eletricos/byd.png" />
                  <img src="assets/carros-eletricos/byd.png" alt="BYD Song Plus elétrico" />
                </picture>
              </div>
            </div>
            <div className="carros-eletricos-mais-cars-card">
              <h4 className="carros-eletricos-mais-cars-title">
                <b>2°</b> BYD Dolphin Mini
              </h4>
              <p className="carros-eletricos-mais-subtitle"> Veículo Elétrico a Bateria (BEV)</p>
              <div className="carros-eletricos-mais-cars-img">
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/carros-eletricos/byd-dolphin-mini.webp"
                  />
                  <source type="image/png" srcSet="assets/carros-eletricos/byd-dolphin-mini.png" />
                  <img
                    src="assets/carros-eletricos/byd-dolphin-mini.png"
                    alt="BYD Dolphin Mini elétrico"
                  />
                </picture>
              </div>
            </div>
            <div className="carros-eletricos-mais-cars-card">
              <h4 className="carros-eletricos-mais-cars-title">
                <b>3°</b> BYD King
              </h4>
              <p className="carros-eletricos-mais-subtitle"> Veículo Recarregável Plug-in (PHEV)</p>
              <div className="carros-eletricos-mais-cars-img">
                <picture>
                  <source type="image/webp" srcSet="assets/carros-eletricos/byd-king.webp" />
                  <source type="image/png" srcSet="assets/carros-eletricos/byd-king.png" />
                  <img src="assets/carros-eletricos/byd-king.png" alt="BYD King elétrico" />
                </picture>
              </div>
            </div>
          </div>
          <WhiteButton
            className="carros-eletricos-mais-btn"
            href="https://www.webmotors.com.br/carros-eletricos?utm_source=SF&umt_medium=carros-eletricos&utm_campaign=encontrar-veiculos"
            target="_blank"
          >
            Encontrar veículos elétricos
          </WhiteButton>
          <div className="carros-eletricos-mais-buscados-circles-2" />
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosMaisBuscados;
